import React from 'react';

export const DrawingEntryStatsRow = ({ label, value }) => (
  <div className="tickets-info">
    <div className="tickets-label">{label}</div>
    <div className="tickets-value notranslate">{value}</div>
  </div>
);
